<template>
  <div class="wrap-logo">
    <div v-if="!isMediumViewport" class="logo-s">
      <div class="box-logo">
        <img src="../../assets/images/aaa.png" width="194" height="165" alt="Adman Awards">
      </div>
      <img class="aat-logo" src="../../assets/images/aat_logo.jpg" width="400" height="92" alt="Advertising Association of Thailand">
    </div>

    <div v-else class="logo-lg">
      <b-container>
        <div class="box-logo">
          <img class="brand-logo" src="../../assets/images/admans_logo.png" width="521" height="135" alt="Adman Awards">
        </div>
        <img class="aat-logo" src="../../assets/images/aat_logo.jpg" width="400" height="92" alt="Advertising Association of Thailand">

        <a href="https://www.facebook.com/AdmanAward/" target="_blank" rel="noopener noreferrer">
          <img src="../../assets/icons/facebook-brands.svg" width="512" height="512" alt="Facebook">
        </a>
        <a href="https://www.youtube.com/channel/UC6H6IbIE1NlJfWeOxfWf1AQ/" target="_blank" rel="noopener noreferrer">
          <img src="../../assets/icons/yt.png" width="32" height="32" alt="YouTube">
        </a>
        <a href="https://www.instagram.com/admanawards/" target="_blank" rel="noopener noreferrer">
          <img src="../../assets/icons/ig.png" width="32" height="32" alt="Instagram">
        </a>
        <a href="https://www.tiktok.com/@admanawards/" target="_blank" rel="noopener noreferrer">
          <img src="../../assets/icons/tt.png" width="32" height="32" alt="TikTok">
        </a>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isMediumViewport: window.matchMedia('(min-width: 768px)').matches
    }
  },

  methods: {
    handleMediumBreakpointChange (event) {
      this.isMediumViewport = event.matches
    }
  },

  mounted () {
    this.mediumMediaQuery = window.matchMedia('(min-width: 768px)')

    if (this.mediumMediaQuery.addEventListener) {
      this.mediumMediaQuery.addEventListener('change', this.handleMediumBreakpointChange)
    } else {
      this.mediumMediaQuery.addListener(this.handleMediumBreakpointChange)
    }
  },

  beforeDestroy () {
    if (!this.mediumMediaQuery) return

    if (this.mediumMediaQuery.removeEventListener) {
      this.mediumMediaQuery.removeEventListener('change', this.handleMediumBreakpointChange)
    } else {
      this.mediumMediaQuery.removeListener(this.handleMediumBreakpointChange)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-logo {
  .logo-s {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .box-logo {
      width: 90px;
      height: auto;
      background-color: $active;

      img {
        margin-left: -1px;
        width: auto;
        height: 55px;
      }
    }

    .aat-logo {
      width: auto;
      height: 45px;
    }
  }

  .logo-lg {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
.wrap-logo {
  padding-top: 55px;

  .logo-s {
    display: none;
  }

  .logo-lg {
    display: block;

    height: 68px;
    background: linear-gradient(
      90deg, rgba(0,0,0,1) 0%,
      rgba(0,0,0,1) 5%,
      rgba(255,255,255,1) 5%,
      rgba(255,255,255,1) 100%
    );

    @media only screen and (min-width: 1024px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 20%,
        rgba(255,255,255,1) 20%,
        rgba(255,255,255,1) 100%
      );
    }

    @media only screen and (min-width: 1440px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 25%,
        rgba(255,255,255,1) 25%,
        rgba(255,255,255,1) 100%
      );
    }

    @media only screen and (min-width: 2245px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 30%,
        rgba(255,255,255,1) 30%,
        rgba(255,255,255,1) 100%
      );
    }

    .container {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      @media only screen and (max-width: 1023px) {
        max-width: 960px;
      }

      .box-logo {
        display: flex;
        align-items: center;
        flex: 1 1 215px;
        max-width: 320px;
        min-width: 0;
        height: 68px;
        background-color: $active;
        animation: boxLogo 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

        img {
          margin-left: -1px;
          animation: logo 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        }

        .brand-logo {
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .aat-logo {
        flex-shrink: 0;
        margin-left: 0px;
        width: auto;
        height: 65px;
        border-right: 1px solid #ccc;
      }

      a {
        flex-shrink: 0;
        margin-left: 16px;
        opacity: 0.3;
        // position: absolute;
        left: calc(50% + 92px);
        // transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

        @media only screen and (min-width: 1024px) {
          left: calc(50% + 172px);
        }

        @media only screen and (min-width: 1200px) {
          left: calc(50% + 92px);
        }

        img {
          width: auto;
          height: 32px;
        }
      }

      a:hover {
        opacity: 1;
      }
    }
  }
}
}

@keyframes boxLogo {
  0% {
    transform: translateX(-100px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes logo {
  0% {
    opacity: 0;
    transform: translateX(-150px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
